import type { PropsWithChildren, ReactNode } from 'react';
import { PLACEHOLDERS } from '../../constants/pdf-preview.ts';
import { usePlaceholders } from '../placeholders-context.tsx';
import { Placeholder } from './internals/placeholder';

export function TermsAndConditionsPlaceholder({ children }: PropsWithChildren): ReactNode {
  const { showPlaceholder } = usePlaceholders(PLACEHOLDERS.TermsAndConditions);

  if (showPlaceholder) {
    return <Placeholder width="438px" />;
  }

  return <>{children}</>;
}
